export enum RouteName {
  AiHistory = "aiHistory",
  AiLandingPage = "AiLandingPage",
  AiLandingPageWithCategory = "AiLandingPageWithCategory",
  MyItemDetail = "myCollectionItemDetail",
  Dashboard = "dashboard",
  SavedItems = "savedItems",
  ArticleDraft = "articleDraft",
  Collector = "collector",
  Chat = "chat",
  ChatEmailNotificationsUnsubscribed = "chatUnsubscribed",
  ChatEmailNotificationsUnsubscribeError = "chatUnsubscribeError",
  Portfolio = "portfolio",
  AiForm = "aiForm",
  AiFormWithPreselectedCategory = "aiFormWithPreselectedCategory",
  AiDetail = "aiDetail",
  Catalogue = "catalogueStart",
  CatalogueItem = "catalogueItem",
  CatalogueCategory = "catalogueCategory",
  Homepage = "homepage",
  LandingPageCategory = "landingPageCategory",
  PublicItemDetail = "publicItemCard",
  About = "about",
  Gdpr = "gdpr",
  Tac = "tac",
  Guide = "guide",
  Magazine = "articlesList",
  Article = "article",
  Contacts = "contacts",
  Collectors = "collectors",
  Registration = "registrationNew",
  RegistrationEmailVerified = "registrationEmailVerified",
  Login = "login",
  PasswordRestore = "forgottenPassword",
  PasswordRestoreProcessing = "forgottenPasswordProcessing",
  FacebookSsoCallback = "facebookSsoCallback",
  AccountSetup = "accountSetup",
  Error404 = "error404",

  /**
   * ==============================================
   * Account
   * ==============================================
   */

  AccountSettings = "accountSettings",
  YearInReview = "yearInReview",

  /**
   * ==============================================
   * Marketplace
   * ==============================================
   */

  Marketplace = "marketplace",
  ShoppingCart = "shoppingCart",
  MarketplaceOrder = "marketplaceOrder",
  MarketplaceOrderSuccess = "marketplaceOrderSuccess",
  MarketplaceOrderFail = "marketplaceOrderFail",
  MarketplaceItem = "marketplaceItem",
  MarketplaceItemCreated = "marketplaceItemCreated",
  Sales = "saleList",
  Sale = "saleDetail",
  Purchases = "purchaseList",
  Purchase = "purchaseDetail",

  /**
   * ==============================================
   * Comic-con
   * ==============================================
   */

  ComicCon = "comicCon",
  ComicConTerms = "comicConTerms",

  /**
   * ==============================================
   * Others
   * ==============================================
   */

  Support = "support",
}
